module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [_c('header-bar'), _vm._v(" "), _c('section', {
    staticClass: "profile-header"
  }, [_c('div', {
    staticClass: "grid-inner"
  }, [_vm._m(0), _vm._v(" "), (_vm.hasIdea) ? _c('div', {
    staticClass: "col-6"
  }, [_c('h2', [_vm._v("Countries")]), _vm._v(" "), _c('p')]) : _vm._e()])]), _vm._v(" "), _c('section', {
    staticClass: "profile-body"
  }, [_c('div', {
    staticClass: "grid-inner"
  }, [_c('div', {
    staticClass: "col-5"
  }, [(_vm.countries) ? _c('h4', [_vm._v("Regions of interest:")]) : _vm._e(), _vm._v(" "), _c('div', _vm._l((_vm.countries), function(item, key) {
    return _c('country', {
      key: key,
      attrs: {
        "itemid": key
      }
    })
  }))])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "image-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c9246504"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CountriesExample.vue
// module id = 732
// module chunks = 1